import en from '../src/locales/en/translation.json'
import ko from '../src/locales/ko/translation.json'


export const languages = {
    en: en,
    ko: ko,
}